import App from './App.vue'
import router from './router'
import { antComponents } from './antd'
import { CommonComponents } from './use-common-components'
import 'virtual:svg-icons-register'
import store, { storeKey } from './store'
import { createInstance } from '/@/root'
import { useDirectives } from './directives'
import VueCesium from 'vue-cesium'
import 'vue-cesium/dist/index.css'
import zhHans from 'vue-cesium/es/locale/lang/zh-hans'
import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'

import '/@/styles/index.scss'

/**
 * 加载 SVG Sprite 图标集合
 */
function loadSvgSprite () {
  // 检查是否已经加载过
  if (document.getElementById('svg-icons-sprite')) {
    return Promise.resolve()
  }

  return fetch('/icons-sprite.svg')
    .then(response => {
      if (!response.ok) {
        throw new Error('SVG sprite 文件加载失败')
      }
      return response.text()
    })
    .then(svgContent => {
      // 创建容器并插入 SVG sprite
      const container = document.createElement('div')
      container.innerHTML = svgContent
      container.style.position = 'absolute'
      container.style.width = '0'
      container.style.height = '0'
      container.style.visibility = 'hidden'
      container.style.overflow = 'hidden'
      container.id = 'svg-icons-sprite'
      document.body.insertBefore(container, document.body.firstChild)
      console.log('SVG sprite 加载成功')
    })
    .catch(err => {
      console.warn('SVG sprite 加载失败，将使用 vite-plugin-svg-icons 提供的图标:', err)
    })
}

// 在应用初始化前加载 SVG sprite
loadSvgSprite()

dayjs.locale('zh-cn')
const app = createInstance(App)

app.use(store, storeKey)
app.use(router)
app.use(CommonComponents)
app.use(antComponents)
app.use(useDirectives)
app.use(VueCesium, {
  cesiumPath: '/Cesium/Cesium.js',
  accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1NmMyZjgzMi0xNGJjLTRlNGEtYmM3Ni0wMDFhODM0ODQzNzciLCJpZCI6MjEwMzM1LCJpYXQiOjE3MTM3NzA4NDJ9.zxQNYYpA3XwcYMa1mL98rMs7ZRf8mSwknSJQ9OWIjLg',
  locale: zhHans
})
app.mount('#demo-app')
